import { takeLeading, call, put } from "redux-saga/effects";
import {
  stylesSetAll,
  styleAddOne,
  styleUpdateOne,
  styleRemoveOne,
  removeChosenStyle,
} from "../slices/styles.slice";
import { loadingEdit, errorEdit } from "../slices/status.slice";
import { stylesService } from "../../services";
import { modalEdit } from "../slices/modal.slice";
import { contentEdit } from "../slices/modal.slice";

export function* getAll(action) {
  const response = yield call(stylesService.getAll, {
    userId: action.payload.userId,
  });
  yield put(stylesSetAll(response.data));
}

function* addOne(action) {
  yield put(loadingEdit(true));
  try {
    const response = yield call(stylesService.create, action.payload);
    const { id, styleName, userId } = response.data.style;
    yield put(
      styleAddOne({
        id,
        styleName,
        userId,
        teacherAndstyles: [],
        styleColor: action.payload.styleColor
      })
    );
    yield put(contentEdit("New style has been created"));
    yield put(modalEdit("Confirm"));
  } catch (error) {
    if (error.response) {
      const msg = error.response.data?.message || JSON.stringify(error.response.data) || 'Server error (' + error.response.status + ')';
      yield put(errorEdit(msg));
    } else if (error.message) {
      yield put(errorEdit('Client error: ' + error.message));
    } else {
      yield put(errorEdit("Something has gone wrong. Please try again later"));
    }
  } finally {
    yield put(loadingEdit(false));
  }
}

function* updateOne(action) {
  yield put(loadingEdit(true));
  try {
    yield call(stylesService.update, action.payload);
    yield put(styleUpdateOne(action.payload));
    yield put(removeChosenStyle());
    yield put(contentEdit("The style has  been updated"));
    yield put(modalEdit("Confirm"));
  } catch (error) {
    if (error.response) {
      const msg = error.response.data?.message || JSON.stringify(error.response.data) || 'Server error (' + error.response.status + ')';
      yield put(errorEdit(msg));
    } else if (error.message) {
      yield put(errorEdit('Client error: ' + error.message));
    } else {
      yield put(errorEdit("Something has gone wrong. Please try again later"));
    }
  } finally {
    yield put(loadingEdit(false));
  }
}

function* removeOne(action) {
  yield put(loadingEdit(true));
  try {
    yield call(stylesService.delete, {
      styleId: action.payload.styleId,
      userId: action.payload.userId,
    });
    yield put(styleRemoveOne(action.payload.styleId));
    yield put(removeChosenStyle());
    yield put(contentEdit("The style has been deleted"));
    yield put(modalEdit("Confirm"));
  } catch (error) {
    if (error.response) {
      const msg = error.response.data?.message || JSON.stringify(error.response.data) || 'Server error (' + error.response.status + ')';
      yield put(errorEdit(msg));
    } else if (error.message) {
      yield put(errorEdit('Client error: ' + error.message));
    } else {
      yield put(errorEdit("Something has gone wrong. Please try again later"));
    }
  } finally {
    yield put(loadingEdit(false));
  }
}

export default function* watchStylesSaga() {
  yield takeLeading("STYLES_GET_ALL", getAll);
  yield takeLeading("STYLE_ADD_ONE", addOne);
  yield takeLeading("STYLE_UPDATE_ONE", updateOne);
  yield takeLeading("STYLE_REMOVE_ONE", removeOne);
}
